import { inject } from '@angular/core';
import { ENDPROCESS, PAGETYPE } from 'src/app/core/enums/enums';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';

export const FinalProcessGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);

  const endProcessOnSalesForce: boolean = JSON.parse(
    window.sessionStorage.getItem(ENDPROCESS.endProcessOnSalesForce)
  );

  if (endProcessOnSalesForce) {
    router.navigate([PAGETYPE.endProcess]);
    return false;
  } else {
    return true;
  }
};
